import { BaseException } from './baseException.js';

export class PulseApiException extends BaseException
{
    constructor(exception)
    {
        super((exception || {}).message);

        // Work around for 'instanceof' not working as expected
        // https://github.com/babel/babel/issues/4485#issuecomment-315569892
        this.constructor = PulseApiException 
        this.__proto__   = PulseApiException.prototype

        Object.defineProperty(this, 'name', {
            configurable: true
            , enumerable : false
            , value : PulseApiException.name
            , writable : true
        });

        if (typeof Error.captureStackTrace === 'function')
        {
            Error.captureStackTrace(this, this.constructor);
        }
        else
        {
            Object.defineProperty(this, 'stack', {
                configurable: true
                , enumerable : false
                , value : (new Error(message)).stack
                , writable : true,
            });
        }

        this._innerException = exception || {};

        if (this._innerException.stack)
        {
            this.stack = this._innerException.stack;
        }
        else if (exception && typeof Error.captureStackTrace === 'function')
        {
            Error.captureStackTrace(this, this.constructor);
        }

        this.requestUrl      = ((this._innerException.response || {}).request || {}).responseURL;
        this.responseStatus  = (this._innerException.response  || {}).status;
        this.requestHeaders  = (this._innerException.config    || {}).headers;
        this.responseHeaders = ((this._innerException.response || {}).request || {}).responseHeaders;
        this.hasHmac         = (this._innerException.config    || {}).hmac    || false;
        this.timedOut        = ((this._innerException.response || {}).request || {})._timedOut || false;
        this.responseText    = ((this._innerException.response || {}).request || {})._response;
    }
}